module.exports = __webpack_public_path__ + "img/13.50095c5c.jpg";